import { InputHTMLAttributes, useContext } from 'react';
import classNames from 'classnames';
import { RadioContext } from '../RadioContext';
import styles from './styles.module.scss';

interface IRadioProps extends Partial<InputHTMLAttributes<HTMLInputElement>> {
  value: string;
}

const Radio = ({ value, children, className, ...props }: IRadioProps) => {
  const { selectedValue, setSelectedValue, name } = useContext(RadioContext);

  return (
    <label className={classNames(styles.container, className)}>
      <input
        type='radio'
        name={name}
        value={value}
        checked={value === selectedValue}
        onChange={() => setSelectedValue?.(value)}
        {...props}
      />
      <div className={styles.content}>{children}</div>
    </label>
  );
};

export default Radio;
